// search.js — Search page specific code
// Loaded only on the search results page.
// Handles: filters, sort, pagination, load-more.

// ============================================
// FILTER CHECKBOX SYNC
// ============================================

// Sync duplicate checkboxes (same filter appears in "Popular filters" and its own section).
// Without this, unchecking one copy leaves the other checked.
function syncFilter(el) {
    var form = el.form;
    if (!form) return;
    var boxes = form.querySelectorAll('input[type="checkbox"][name="filters"][value="' + CSS.escape(el.value) + '"]');
    for (var i = 0; i < boxes.length; i++) {
        boxes[i].checked = el.checked;
    }
}

// Sync duplicates then submit (desktop filters auto-submit on change).
function syncFilterAndSubmit(el) {
    syncFilter(el);
    if (el.form) el.form.submit();
}

// ============================================
// SORT & PAGINATION
// ============================================

function onSortChange(value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort', value);
    window.location.href = url.toString();
}

function goToPage(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    window.location.href = url.toString();
}

// ============================================
// LOAD MORE (Alpine.js component)
// ============================================

function loadMore(config) {
    return {
        currentPage: config.currentPage || 1,
        totalCount: config.totalCount || 0,
        pageCount: config.pageCount || 1,
        displayedCount: config.initialCount || 0,
        loading: false,

        get hasMore() {
            return this.currentPage < this.pageCount;
        },

        async loadNextPage() {
            if (this.loading || !this.hasMore) return;
            this.loading = true;

            try {
                const url = new URL(window.location.href);
                url.pathname = '/api/search/html';
                url.searchParams.set('page', this.currentPage + 1);

                const response = await fetch(url.toString());
                if (!response.ok) throw new Error('Failed to load results');

                const html = await response.text();

                const totalCount = parseInt(response.headers.get('X-Total-Count'));
                const pageCount = parseInt(response.headers.get('X-Page-Count'));
                const currentPage = parseInt(response.headers.get('X-Current-Page'));

                if (!isNaN(totalCount)) this.totalCount = totalCount;
                if (!isNaN(pageCount)) this.pageCount = pageCount;
                if (!isNaN(currentPage)) this.currentPage = currentPage;

                const list = document.getElementById('property-list');
                if (list && html.trim()) {
                    list.insertAdjacentHTML('beforeend', html);
                    this.displayedCount = list.querySelectorAll(':scope > article').length;
                }
            } catch (err) {
                console.error('Load more failed:', err);
            } finally {
                this.loading = false;
            }
        }
    };
}
